import { OnlineMatchesFeedback } from '@pflegia/types/common/enums/online-matches-feedback.enum';

import { OnlineMatchStatus } from '../match/online-match-status';

export const MAXIMUM_MESSAGE_LENGTH = 10000;
export const MAX_CHAT_FILTER_LENGTH = 1000;
export const MAX_CHAT_AUTOCOMPLETE_LENGTH = 200;
export const MAX_CHAT_REGULAR_INPUT_LENGTH = 200;

export const UNREAD_ONLINE_MATCH_STATUS: OnlineMatchStatus[] = [OnlineMatchStatus.FollowUp, OnlineMatchStatus.KamRequest];
export const UNREAD_ONLINE_MATCHES_FEEDBACK: OnlineMatchesFeedback[] = [
  OnlineMatchesFeedback.OtherMissingQualification,
  OnlineMatchesFeedback.NoOneYearQualification,
  OnlineMatchesFeedback.NoTwoYearQualification,
  OnlineMatchesFeedback.NoThreeYearQualification,
  OnlineMatchesFeedback.No43Or53,
  OnlineMatchesFeedback.NoLg1OrLg2,
];
